import React from 'react';
import { Typography } from '@mui/material';

const PreviewStats = ({ preview }) => {
  const counts = preview?.counts ?? {};
  return (
    <div>
      <div>
        <Typography>Buildings: {counts.buildings.toLocaleString()}</Typography>
      </div>
      <div>
        <Typography>Equipment Types: {counts.equipmentTypes.toLocaleString()}</Typography>
      </div>
      <div>
        <Typography>Equipment: {counts.equipment.toLocaleString()}</Typography>
      </div>
      <div>
        <Typography>Point Types: {counts.pointTypes.toLocaleString()}</Typography>
      </div>
      <div>
        <Typography>Points: {counts.points.toLocaleString()}</Typography>
      </div>
    </div>
  );
};

export default PreviewStats;
